import axios from "axios";
import { API_BASE_URL } from '../config';

const ExistingEventServices = async (token, userData) => {
    try {
        if (!token) {
            throw new Error('No token available');
        }

        const response = await axios.get(`${API_BASE_URL}exits-user-event/`, {
            params: {
                user_id: userData.user_id,
            },
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        return response.data;
    } catch (error) {
        throw new Error(error);
    }
}

export default ExistingEventServices;